import { BillingMainContainerComponent } from '../../../components/dashboard/loggedin-content/billing-new/billing-main-container/billing-main-container.component';
import { AutoPayPromotionBannerComponent } from '../../../components/dashboard/loggedin-content/my-insurance/auto-pay-promotion-banner/auto-pay-promotion-banner.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { AcmicService } from '@mapfre-design-library/src/public_api';
import { EventService } from '@services/event-service.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, AutoPayPromotionBannerComponent, BillingMainContainerComponent],
  selector: 'app-billing-container',
  templateUrl: './billing-container.component.html',
  styleUrls: ['./billing-container.component.scss']
})
export class BillingContainerComponent implements OnInit {
  policyNumber: string;
  policy: any;
  isAcmic = false;
  constructor(
    private eventService: EventService,
    private acmicService: AcmicService
  ) { }

  
  ngOnInit(): void {
    this.isAcmic = this.acmicService.isACMIC();
    this.eventService.childEventListner().subscribe(data => {
      if(data) {
        setTimeout(() => {
          this.policy = data?.autopayNoticationPolicyData;
        },0);
      }
    })
  }

}
